import React, { useState } from 'react';
import { Search, X, Plane } from 'lucide-react';
import Logo from '../../components/Logo';
import Footer from '../../components/Footer';
import ThemeToggle from '../../components/ThemeToggle';
import WalletMenu from '../../components/WalletMenu';
import NavigationMenu from '../../components/NavigationMenu';

export default function NFTCollection() {
  const [searchTerm, setSearchTerm] = useState('');

  return (
    <div className="min-h-screen flex flex-col">
      <header className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-b from-gray-50 to-white border-b border-gray-100">
        <div className="max-w-8xl mx-auto">
          <div className="flex items-center justify-between py-4 px-6">
            <div className="flex items-center gap-8">
              <Logo />
              <NavigationMenu />
            </div>
            <div className="flex items-center gap-4">
              <WalletMenu onShowDashboard={() => {}} />
              <ThemeToggle />
            </div>
          </div>
        </div>
      </header>

      <main className="flex-1 pt-[88px]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Flight NFT Collection</h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Own a piece of aviation history with our exclusive collection of flight NFTs. Each token represents a unique private jet journey, immortalized on the blockchain with verifiable carbon offset certificates.
            </p>
          </div>

          <div className="mb-8">
            <div className="max-w-xl mx-auto">
              <div className="relative">
                <Search size={20} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="text"
                  placeholder="Search by flight number, route, or aircraft type..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
                />
                {searchTerm && (
                  <button
                    onClick={() => setSearchTerm('')}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                  >
                    <X size={16} />
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* Info Box: No NFTs Available */}
          <div className="text-center py-16 bg-gray-50 rounded-xl">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Plane size={24} className="text-gray-400" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900">No NFTs Available Yet</h3>
            <p className="text-gray-500 mt-2 max-w-md mx-auto">
              Our NFT collection is launching soon. Each flight will be minted as a unique NFT with verifiable carbon offset certificates.
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
